
import React from 'react'
import { Grid } from'@mui/material'
import { withComponentContext } from 'widgets-shared/core'
import { withTranslations } from 'widgets-shared/core'
import { compose } from 'widgets-shared/core'
import { competitionTranslations } from 'smartstream-widgets/constants/competitions'
import FuturesHeader from './FuturesHeader/FuturesHeader'
import CompetitorMarketRow
  from 'smartstream-widgets/components/CompetitorMarketRow/CompetitorMarketRow'

import { TranslationFunction } from 'smartstream-widgets/types/sharedModule/core'
import { withStyles, createStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles';
import { FuturesComponentProps } from './types'
import { Competitor } from "smartstream-widgets/types/competitor"
import { getDefaultTheme } from 'smartstream-widgets/utils/getDefaultTheme'
import { withComponentContextProvider } from 'widgets-shared/core'

const styles = (theme: Theme) =>  createStyles({
  captionOdd: {},
  competitorName: {
    color: theme.palette.text.primary
  },
  competitors: {
    flex: 1,
    padding: `0px ${theme.spacing()}`
  },
  marketSelection: {
    backgroundColor: 'transparent',
    color: theme.palette.secondary.main,
    '&$marketSelectionDisabled': {
      '& $captionOdd': {
        color: theme.palette.text.secondary
      }
    },
    '&:hover': {
      background: theme.palette.secondary.main,
      '& $captionOdd': {
        color: theme.palette.secondary.contrastText
      }
    }
  },
  marketSelectionDisabled: {},
  header: {
    flex: `0 ${theme.spacing(7)}`
  },
  root: {
    height: '100%',
    paddingBottom: theme.spacing(5)
  }
})

export function FuturesComponent (props: FuturesComponentProps) {
  const {
    className = '',
    classes,
    config: {
      rowsPerSlide = 5,
      noAdvertsRowsPerSlide = 10
    },
    containerRef,
    data: {
      competitionId,
      competitionName,
      fixtureId,
      competitors,
      markets = [],
      name: fixtureName,
      sportId
    },
    showMoreRows,
    translations
  } = props

  const { name: marketName, selections = [], sourceId } = markets.find(
    market => market.selections.length > 0) || {}
  const hasAlternateLogo = (fixtureName && fixtureName.includes('NASCAR'))
    || competitionId === "635" || sportId === "16"
  const formattedCompetitionName = translations[competitionId] || competitionName

   return (
    <Grid
      container
      className={`${className} ${classes.root}`}
      direction='column'
      wrap='nowrap'
      data-testid='futures-component-container'
    >
      <FuturesHeader
        classes={{ root: classes.header }}
        competitionId={competitionId}
        competitionName={`${formattedCompetitionName || ''} ${fixtureName}`}
        containerRef={containerRef}
        marketName={marketName}
      />
      <Grid
        container
        className={classes.competitors}
        component='main'
        direction='column'
        justifyContent='space-between'
        wrap='nowrap'
      >
        {
          selections
            .slice(0, showMoreRows ? noAdvertsRowsPerSlide : rowsPerSlide)
            .map((selection, index) => {
              const { competitorId } = selection
              const competitor = competitors.find(competitor => competitor.competitorId === competitorId) || {} as Competitor
              const market = { selection, sourceId }
              const displayName = competitor.displayName
              const useDisplayName = displayName && displayName[0]
              const defaultName = competitor.shortName || competitor.officialName
              const rowName = useDisplayName? displayName.join(' ') : defaultName

              return <CompetitorMarketRow
                classes={{
                  competitorName: classes.competitorName,
                  marketSelection: classes.marketSelection,
                  root: classes.competitorRoot,
                  captionOdd: classes.captionOdd,
                  marketSelectionDisabled: classes.marketSelectionDisabled
                }}
                competitorsBrand={[competitor.brand]}
                key={competitorId}
                logoMode={hasAlternateLogo ? 'logo' : 'logoFlag'}
                market={market}
                name={rowName}
                position={index + 1}
                id={`${competitorId}-${fixtureId}`}
              />
            })
        }
      </Grid>
    </Grid>
  )
}

const FuturesComponentComposed = compose(
  withComponentContext,
  withStyles(styles, { name: 'FuturesComponent' , defaultTheme: getDefaultTheme}),
  withTranslations((t: TranslationFunction) => competitionTranslations(t))
)(FuturesComponent) as React.ElementType

export default FuturesComponentComposed
export const FuturesComponentWithContext = withComponentContextProvider(FuturesComponentComposed) as React.Component